import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTransactions } from "../slice/transactionSlice";
import { useEffect } from "react";
import Loading from "./Loading"
import SummaryTable from "./summaryTable";


const Summary = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.other);
  const { user } = useSelector((state) => state.user);

  useEffect(()=>{
    console.log("called api");
    dispatch(fetchTransactions());
  },[user]);


  return (
    <>
      {isLoading ? <Loading/> : <SummaryTable />}
    </>
  );
}

export default Summary;